import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Route, useHistory } from 'react-router-dom';
import cookie from 'react-cookies';
import { ROLE, cleanUser } from '@/modules/User';

const ProtectRoute = ({
  protect,
  state,
  user,
  olimpic,
  requests,
  to,
  onLogout,
  component: Component,
  layout: Layout,
  authenticated,
  ...rest
}) => {
  const history = useHistory();

  useEffect(() => {
    if (!authenticated) {
      history.push('/signin');
    }
  }, [authenticated]);

  useEffect(() => {
    if (
      !user._id ||
      !olimpic ||
      user.role === ROLE.ADMIN ||
      user.meta?.smgl ||
      user.purchases?.olimpic_3 ||
      olimpic?.participant
    )
      return;

    onLogout();
    history.push('/purchase');
  }, [user.user, olimpic]);

  useEffect(() => {
    if (!protect(state)) {
      history.push(to);
    }
  });

  return (
    <Route
      {...rest}
      render={props =>
        authenticated && (
          <Layout>
            <Component {...props} />
          </Layout>
        )
      }
    />
  );
};

ProtectRoute.propTypes = {
  component: PropTypes.oneOfType([
    PropTypes.func.isRequired,
    PropTypes.object.isRequired,
  ]).isRequired,
  layout: PropTypes.oneOfType([
    PropTypes.func.isRequired,
    PropTypes.object.isRequired,
  ]).isRequired,
  authenticated: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired,
  state: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  olimpic: PropTypes.object.isRequired,
  requests: PropTypes.object.isRequired,
  protect: PropTypes.func,
  onLogout: PropTypes.func.isRequired,
  to: PropTypes.string,
};

ProtectRoute.defaultProps = {
  protect: () => true,
  to: '/fallback',
};

const mapStateToProps = state => ({
  authenticated: state.user.token !== '',
  state,
  user: state.user,
  olimpic: state.olimpic.sama,
  requests: state.requests,
});

const mapDispatchToProps = dispatch => ({
  onLogout() {
    cookie.remove('Authorization', { path: '/' });
    dispatch(cleanUser());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ProtectRoute);
